var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBriefcaseJob = function SvgBriefcaseJob(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M2.016 7.974A3 3 0 0 0 5 10.667h6a3 3 0 0 0 2.985-2.693m-11.97 0C2 8.33 2 8.767 2 9.334c0 1.24 0 1.86.163 2.363a3.334 3.334 0 0 0 2.14 2.14C4.805 14 5.426 14 6.667 14h2.666c1.241 0 1.862 0 2.364-.163a3.334 3.334 0 0 0 2.14-2.14C14 11.195 14 10.574 14 9.333c0-.566 0-1.004-.015-1.36m-11.97 0c.019-.422.06-.73.148-1.003a3.333 3.333 0 0 1 2.14-2.14c.279-.09.594-.131 1.03-.149m8.652 3.293c-.019-.423-.06-.731-.148-1.004a3.334 3.334 0 0 0-2.14-2.14c-.279-.09-.593-.131-1.03-.149m0 0v-.014c0-.62 0-.93-.069-1.185a2 2 0 0 0-1.414-1.414C8.93 2 8.62 2 8 2s-.93 0-1.184.068A2 2 0 0 0 5.4 3.482c-.068.255-.068.565-.068 1.185v.014m5.334 0c-.351-.014-.78-.014-1.334-.014H6.667c-.553 0-.983 0-1.334.014M8 10v1.333"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcaseJob);
export default ForwardRef;